import { createFileRoute } from '@tanstack/react-router'
import { ManageDataPage } from '@/components/features/ManageDataPage'

export const Route = createFileRoute('/_authenticated/manage-data')({
	component: ManageDataPage,
})
